export default __webpack_public_path__ + "static/product-unit-7-mobile-a277f39387a188568c5af762a9e4a8ef.png";